import { render } from "./imagelink.vue?vue&type=template&id=8fe64c18"
import script from "./imagelink.vue?vue&type=script&lang=js"
export * from "./imagelink.vue?vue&type=script&lang=js"

import "./imagelink.vue?vue&type=style&index=0&id=8fe64c18&lang=scss"

import exportComponent from "/var/deploy/beta/web_head/releases/20260122001113/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__